import { render, staticRenderFns } from "./GameSettings.vue?vue&type=template&id=386a8c5a&scoped=true&"
import script from "./GameSettings.vue?vue&type=script&lang=js&"
export * from "./GameSettings.vue?vue&type=script&lang=js&"
import style0 from "./GameSettings.vue?vue&type=style&index=0&id=386a8c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386a8c5a",
  null
  
)

export default component.exports